import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, TextField, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import AddmultipleTables from "./AddTablesforSelected";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI302_2 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [units, SetUnit] = useState("");
  const [formData, setFormData] = useState({
    conversionFactors: "",
    standardsMethodologies: "",
  });
  const [list, setList] = useState([]);
  const [addTables, setaddTables] = useState([
    {
      category: "",
      outsideBoundry: "",
      consumption: "",
      unit: units,
      remark: "",
    },
  ]);
  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = {
    //   defalut: "Product Name",
    colwidth: "12%",
    fields: [
      {
        title: "Categories",
        type: "select",
        fieldName: "category",
        list: ["Upstream", "Downstream"],
      },
      {
        title: "Activity outside organizational boundary",
        type: "select",
        list: list,
        fieldName: "outsideBoundry",
        width:"19%"
      },
      { title: "Consumption", type: "number", fieldName: "consumption",width:"10%" },
      {
        title: "Unit",
        type: "select",
        list: ["MJ", "GJ", "TJ"],
        fieldName: "unit",
        disabled: true,
        width:"10%"
      },
      { title: "Remark", fieldName: "remark",width:"9%" },
    ],
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        const response = res.data.data.GRI300.energyConsumptionOutside;
        const unit =
          res.data.data.GRI300.energyConsumption
            ?.totalFuelConsumptionNonRenewable?.unit;
        SetUnit(
          res.data.data.GRI300.energyConsumption
            ?.totalFuelConsumptionNonRenewable?.unit
        );
        setaddTables(
          response.outsideOrganization.length > 0
            ? response.outsideOrganization.map((item) => ({
                category: item.category,
                outsideBoundry: item?.outsideBoundry,
                consumption: item?.consumption,
                unit: unit || item?.unit,
                remark: item?.remark,
              }))
            : [...addTables]
        );
        setFormData({
          conversionFactors: response?.conversionFactors,
          standardsMethodologies: response?.standardsMethodologies,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleAdd = () => {
    setaddTables((prev) => [
      ...prev,
      {
        category: "",
        outsideBoundry: "",
        consumption: "",
        unit: units,
        remark: "",
      },
    ]);
  };

  console.log("handleChangeTable1", addTables);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("handleChange", name, value);
    if (!/^\d*$/.test(value)) return;
    const [main, sub] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      ...(sub
        ? { [main]: { ...prev[main], [sub]: value } } // If nested, update sub-field
        : { [main]: value }), // If no sub-field, update main field
    }));
  };

  const handleChangeText = (e) => {
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      ...(sub
        ? { [main]: { ...prev[main], [sub]: value } } // If nested, update sub-field
        : { [main]: value }), // If no sub-field, update main field
    }));
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    console.log("handleChange", name, value);
    const [main, sub] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      ...(sub
        ? { [main]: { ...prev[main], [sub]: value } } // If nested, update sub-field
        : { [main]: value }), // If no sub-field, update main field
    }));
  };

  const handleSubmit = async () => {
    if (!disabled) {
      const dataTosend = {
        outsideOrganization: [...addTables],
        ...formData,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          submitted302_2: true,
          energyConsumptionOutside: { ...dataTosend },
        })
          .then((res) => navigate(`/gri/gri300/302-3/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/302-3/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide &&<p className={styles.section_heading} style={{ textDecoration: "none" }}>
        302 : <span className={styles.main_heading_underline}>ENERGY</span>
      </p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        302-2 :{" "}
        <span className={styles.main_heading_underline}>
          Energy consumption outside of the organization
        </span>
      </p>
      <p
        className={styles.ques_heading}
        style={{
          // marginTop: "2.5rem",
          marginRight: "1rem",
          marginBottom: hide ? "-1rem" : "0.5rem",
          display: "flex",
        }}
      >
        a. Energy consumption outside of the organization
      </p>
      <Box sx={{ width: "98.5%", ml: 2 }}>
        <AddmultipleTables
          // title="a. Percentage of reclaimed products and their packaging materials for each product category."
          {...{
            addTables,
            setaddTables,
            errors,
            setErrors,
            inputData,
            setList,
            units,
            //   defaultSegments,
            //   DropDownData,
            handleAdd,
            //   setTotal
            disabled: disabled,
            hide: hide
          }}
        />
      </Box>
      <Box>
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",
            marginRight: "1rem",
            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          b. Describe the standard, methodologies, assumptions, and/or
          calculation tools used.
        </p>
        <TextField
          placeholder="Enter Text"
          name="standardsMethodologies"
          sx={{ width: "98%", ml: 2 }}
          value={formData?.standardsMethodologies}
          onChange={handleChangeText}
          size="small"
          multiline
          minRows={1}
          fullWidth
          disabled={disabled}
        />
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",
            marginRight: "1rem",
            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          c. Provide the source of the conversion factors used.
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          name="conversionFactors"
          multiline
          minRows={1}
          sx={{ width: "98%", ml: 2 }}
          value={formData?.conversionFactors}
          onChange={handleChangeText}
          fullWidth
          disabled={disabled}
        />
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI302_2;
